(function iife() {
	"use strict";

	angular.module("dx.webapp.navigation").constant("DX_URLS", {
		get: function get(route, parameters) {
			var url = this.routes[route];
			if (typeof url !== "string") {
				throw Error("[DX_URLS] Route does not exist: " + route);
			}

			var placeholders = url.match(/:\w+/g);

			if (placeholders) {
				placeholders.forEach(function foreach(placeholder) {
					var value = parameters[placeholder.slice(1)];
					if (value instanceof Array) {
						value = value.join(",");
					}

					url = url.replace(placeholder, value);
				});
			}

			return url;
		},

		routes: Object.freeze({
			// Main stuff
			overview: "/",
			exams: "/exams",
			rubrics: "/rubrics",
			groups: "/groups",
			settings: "/settings",
			regions: "/regions",
			404: "/404",

			// Class stuff
			classView: "/class/:id",
			classAddStudents: "/class/:id/addstudents",
			classEdit: "/class/:id/:edit",
			classInCourse: "/class/:id/:edit/:course",
			classInCourseView: "/class/:id/view/:course",
			classInCourseEdit: "/class/:id/edit/:course",

			// Exam stuff
			examCreate: "/exam/create",
			examView: "/exam/view/:id",
			examEdit: "/exam/edit/:id",
			examPrint: "/exam/print/:id/:examParts/:printSettings/:pageBreakBefore",
			examGrades: "/exam/grades/:id",
			examGradesPrint: "/exam/grades/:id/print/:questionIds/:studentIds/:examParts/:printSettings/:sortOn/:pageBreakBefore",
			examGrading: "/exam/grading/:id",
			examSetAnonymous: "/exam/setanonymous/",
			examSetPublished: "/exam/setpublished/",

			// Live stuff
			livePrint: "/live/print/:id",

			// Archive
			archive: "/archive",

			// Login
			login: "/login",

			// Error
			error: "/error",

			// Register
			register: "/register",
			registerDone: "/register/done",

			// Forgot password
			forgotPassword: "/forgot-password",
			forgotPasswordResetRequestSent: "/forgot-password/reset-request-sent",
			forgotPasswordChange: "/forgot-password/change/:id/:token",
			forgotPasswordPasswordChanged: "/forgot-password/password-changed",

			// Set password (alias of forgot password)
			setPasswordChange: "/set-password/change/:id/:token",
			setPasswordPasswordChanged: "/set-password/password-changed",

			// Verification
			verify: "/verify/:userId/:code",

			// Node
			node: "/node",
			nodeView: "/node/:id",
			nodeMerge: "/node/merge/:id",

			//External tool
			externalToolNew: "/external-tool/:orgId/new",
			externalToolEdit: "/external-tool/:orgId/edit/:id",

			// Invite
			inviteAccept: "/invite/accept/:id/:token",

			// Referral
			referAFriend: "/refer-a-friend",

			// Roles
			roleCreate: "/role/create",
			roleApply: "/role/apply",
			roleView: "/role/view/:nodeId/:roleId",
			roles: "/roles",

			// Master specific tools
			masterTools: "/master-tools",
			masterToolsMoveUserData: "/master-tools/move-user-data",
			masterToolsCleanStudents: "/master-tools/clean-students",
			masterDXEToDXRConverter: "/master-tools/dxe-to-dxr-converter",
			masterToolsSearchIndexList: "/master-tools/search-index-list",
			masterToolsSearchIndex: "/master-tools/search-index/:indexName",
			masterToolsSearchIndexCreate: "/master-tools/search-index-create",
			masterToolsSearch: "/master-tools/search",
			masterToolsUserView: "/master-tools/user/:id",
			masterToolsStudentView: "/master-tools/student/:id",
			masterToolsBulkChangeEmail: "/master-tools/bulk-change-email",
			masterToolsBulkDeleteUser: "/master-tools/bulk-delete-user",
			masterToolsBulkDeleteStudent: "/master-tools/bulk-delete-student",
			masterToolsUserExport: "/api/v1/users/:id/export",
			masterToolsImportTeacherData: "/master-tools/teacher-data",
			masterToolsUserDuplication: "/master-tools/user-duplication",
			masterToolsRecalculateExam: "/master-tools/recalculate-exam",
			masterToolsBulkSetHiddenExams: "/master-tools/bulk-set-hidden-exams",
			masterToolsStudentMerge: "/master-tools/student-merge",
			masterToolsUserMerge: "/master-tools/user-merge",
			masterToolsBulkUnifyPassword: "/master-tools/bulk-unify-password",


			// Rubric (aka Grading Matrix)
			rubricCreate: "/rubric/create",
			rubricEdit: "/rubric/edit/:id",
			rubricPrint: "/rubric/print/:id",

			// Share
			share: "/share/create/",

			// Student
			studentSearch: "/students",
			student: "/student/:id",
			results: "/student/:studentId/results/:examId",
			createStudent: "/student/create",
			activateStudent: "/student/activate/:id/:token",
			deleteStudents: "/students/delete",
			changeStudentCode: "/students/changeCode",

			// Support
			support: "/support",

			// LTI
			ltiContentItemSelection: "/lti/content-item-selection",
			ltiExamPreview: "/lti/preview/:examId",
			ltiExamSelected: "/lti/selected/:examId",
			ltiAssignment: "/lti/assignment/:examId",

			// Skolon
			skolonAuthenticate: "/skolon/authenticate",

			// Import
			import: "/import",

			// Jobs
			jobsList: "/jobs",
			jobsView: "/jobs/:jobId",

			// Client settings
			clientSettings: "/clients",

			// Import students
			importStudents: "/import-students",

			// Remote proctoring, do not use # when binding this to href attributes
			remoteProctoringLogin: "/api/v1/proctoring/proctorlogin/:examId",
		}),
	});
}());
